import React, { createContext, useContext, useState } from 'react';

/**
 * FocusModeContext
 * Provides focus mode state and navigation tabs to be rendered in the navbar
 */
const FocusModeContext = createContext({
  isConsultationActive: false,
  navigationTabsContent: null,
  setNavigationTabsContent: () => {},
});

export const FocusModeProvider = ({ children }) => {
  const [navigationTabsContent, setNavigationTabsContent] = useState(null);
  
  // isConsultationActive is true when navigationTabsContent is set
  const isConsultationActive = navigationTabsContent !== null;

  return (
    <FocusModeContext.Provider
      value={{
        isConsultationActive,
        navigationTabsContent,
        setNavigationTabsContent,
      }}
    >
      {children}
    </FocusModeContext.Provider>
  );
};

export const useFocusMode = () => {
  const context = useContext(FocusModeContext);
  if (!context) {
    throw new Error('useFocusMode must be used within FocusModeProvider');
  }
  return context;
};
